import en from './en-US.json';
import es from './es.json';
import hi from './hi-IN.json';
import it from './it.json';
import pt from './pt-BR.json';

const langs = { en, pt, es, hi, it };

export default langs;
